<!-- src/layout/ChangePassword.vue -->
<template>
  <div class="change-password-modal">
    <Modal
        v-model="showModal"
        title="修改密码"
        @on-ok="confirmChangePassword"
        @on-cancel="closeModal"
        :loading="loading"
    >
      <div class="password-form">
        <div class="form-item">
          <label>旧密码:</label>
          <input
              v-model="oldPassword"
              type="password"
              class="form-input"
              placeholder="请输入旧密码"
          />
        </div>

        <div class="form-item">
          <label>新密码:</label>
          <input
              v-model="newPassword"
              type="password"
              class="form-input"
              placeholder="请输入新密码"
          />
        </div>

        <div class="form-item">
          <label>确认新密码:</label>
          <input
              v-model="confirmPassword"
              type="password"
              class="form-input"
              placeholder="请再次输入新密码"
          />
        </div>

        <div class="password-requirements">
          <p>密码要求:</p>
          <ul>
            <li>至少6位字符</li>
            <li>建议包含字母和数字</li>
          </ul>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>import apiClient from '@/api/index';

export default {
  name: 'ChangePassword',
  data() {
    return {
      showModal: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      loading: false
    };
  },
  methods: {
    open() {
      this.showModal = true;
      this.resetForm();
    },

    close() {
      this.showModal = false;
      this.resetForm();
    },

    resetForm() {
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
    },

    closeModal() {
      this.close();
    },

    async confirmChangePassword() {
      // 验证表单
      if (!this.validateForm()) {
        this.$Modal.remove(); // 关闭loading状态
        return;
      }

      this.loading = true;

      try {
        const response = await apiClient.post('user/change_password', {
          old_password: this.oldPassword,
          new_password: this.newPassword,
          confirm_password: this.confirmPassword
        });

        if (response.data.code === 200) {
          this.$Message.success('密码修改成功，请重新登录');
          this.close();

          // 延迟1秒后跳转到登录页面
          setTimeout(() => {
            // 清除本地存储的用户信息
            localStorage.removeItem('token');
            localStorage.removeItem('userLoggedIn');
            localStorage.removeItem('username');
            localStorage.removeItem('userEmail');

            // 跳转到首页（登录页面）
            this.$router.push({ name: 'TiktokQuery' });

            // 刷新页面确保状态清除
            window.location.reload();
          }, 1000);
        } else {
          this.$Message.error(response.data.msg || '密码修改失败');
        }
      } catch (error) {
        console.error('修改密码失败:', error);
        this.$Message.error('密码修改失败，请稍后重试');
      } finally {
        this.loading = false;
        this.$Modal.remove(); // 关闭loading状态
      }
    },

    validateForm() {
      if (!this.oldPassword) {
        this.$Message.warning('请输入旧密码');
        return false;
      }

      if (!this.newPassword) {
        this.$Message.warning('请输入新密码');
        return false;
      }

      if (!this.confirmPassword) {
        this.$Message.warning('请确认新密码');
        return false;
      }

      if (this.newPassword.length < 6) {
        this.$Message.warning('新密码长度至少6位');
        return false;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.$Message.warning('新密码与确认密码不一致');
        return false;
      }

      if (this.oldPassword === this.newPassword) {
        this.$Message.warning('新密码不能与旧密码相同');
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>.password-form {
  padding: 20px 0;
}

.form-item {
  margin-bottom: 15px;
}

.form-item label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #515a6e;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-input:focus {
  border-color: #2d8cf0;
  outline: none;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
}

.password-requirements {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  color: #515a6e;
}

.password-requirements ul {
  margin: 5px 0 0 20px;
  padding: 0;
}

.password-requirements li {
  margin-bottom: 3px;
}
</style>